var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNoteCroche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08039 14.3377V0H7.94338C7.94338 0.103508 7.94338 0.214683 7.94338 0.325858C7.94338 1.40694 8.38068 2.26567 9.28625 2.87522C9.66163 3.12823 10.0486 3.35442 10.424 3.6036C11.1477 4.07897 11.9062 4.51217 12.5796 5.04505C13.8915 6.08779 14.588 7.5024 14.8435 9.12785C14.9402 9.73356 14.9596 10.3508 14.9983 10.9642C15.0176 11.2862 14.8744 11.4779 14.6229 11.5047C14.3481 11.5354 14.1933 11.3935 14.1237 11.0485C13.8566 9.71823 13.2955 8.52981 12.3628 7.52923C11.3373 6.43282 10.0486 5.88077 8.56257 5.73893C8.36133 5.71976 8.1601 5.71593 7.9279 5.70059V6.03029C7.9279 9.46521 7.9279 12.904 7.9279 16.3389C7.9279 17.2475 7.65314 18.0602 7.02234 18.7196C6.20192 19.5783 5.16864 19.9962 3.97671 20C2.72285 20 1.6354 19.5668 0.814976 18.6237C-0.496929 17.1171 -0.187335 14.9741 1.47286 13.7972C3.14467 12.6126 5.47437 12.789 6.94107 14.2151C6.97203 14.2457 7.00299 14.2726 7.08039 14.3416V14.3377Z",
    fill: "#E72E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNoteCroche);
export default __webpack_public_path__ + "static/media/music-note-croche.f1d9557e22d5a59027e928ac5aa814ba.svg";
export { ForwardRef as ReactComponent };